module.exports = __webpack_public_path__ + "img/79b2860.jpg";